import { Fragment, memo } from 'react';

import { IKnmPreview } from 'APIPackage/KnmSearchModule/interfaces/IKnmPreview';

import styles from './KnmPreview.module.scss';
import { KnmChangeWarning } from './KnmChangeWarning';

interface IKnmControlProps {
  passportData: IKnmPreview;
}

export const KnmControl = memo(({ passportData }: IKnmControlProps) => (
  <div className={styles.ColumnContent}>
    <KnmChangeWarning
      oldKnoOrganization={passportData?.oldKnoOrganization}
      date={passportData?.dateReasonChangeKno}
      type={'KNO'}
    />
    {!!passportData.authorities?.length && (
      <>
        {passportData.authorities.map((authority, authIndex) => (
          <Fragment key={authIndex}>
            <span className={styles.SectionTitle}>
              Орган контроля (надзора) из Федерального реестра государственных и муниципальных услуг (ФРГУ) проводящий
              КНМ
            </span>
            {authority.frguOrgId && (
              <div className={styles.Row}>
                <div className={styles.ColText}>
                  Идентификатор органа контроля (надзора) из Федерального реестра государственных и муниципальных услуг
                  (ФРГУ)
                </div>
                <div className={styles.ColValue}>{authority.frguOrgId}</div>
              </div>
            )}
            {authority.frguOrgName && (
              <div className={styles.Row}>
                <div className={styles.ColText}>
                  Наименование органа контроля (надзора) из Федерального реестра государственных и муниципальных услуг
                  (ФРГУ)
                </div>
                <div className={styles.ColValue}>{authority.frguOrgName}</div>
              </div>
            )}
            {authority.frguOrgOgrn && (
              <div className={styles.Row}>
                <div className={styles.ColText}>ОГРН органа государственного контроля (надзора)</div>
                <div className={styles.ColValue}>{authority.frguOrgOgrn}</div>
              </div>
            )}
            {authority.jointly && (
              <div className={styles.Row}>
                <div className={styles.ColText}>
                  Наименование органа контроля (надзора), совместно с которым проводится КНМ
                </div>
                <div className={styles.ColValue}>{authority.jointly}</div>
              </div>
            )}

            {!!authority.authorityServ?.length && (
              <>
                <span className={styles.SectionTitle}>Список Функции ФРГУ привязанных к проверке</span>
                {authority.authorityServ.map((serv, servIndex) => (
                  <Fragment key={servIndex}>
                    <span className={styles.SectionTitle}>
                      Контрольно-надзорная функция из Федерального реестра государственных и муниципальных услуг (ФРГУ),
                      привязанная к КНМ №1
                    </span>
                    {serv.frguServId && (
                      <div className={styles.Row}>
                        <div className={styles.ColText}>
                          Идентификатор контрольно-надзорной функции из Федерального реестра государственных и
                          муниципальных услуг (ФРГУ)
                        </div>
                        <div className={styles.ColValue}>{serv.frguServId}</div>
                      </div>
                    )}
                    {serv.frguServName && (
                      <div className={styles.Row}>
                        <div className={styles.ColText}>
                          Наименование контрольно-надзорной функции из Федерального реестра государственных и
                          муниципальных услуг (ФРГУ)
                        </div>
                        <div className={styles.ColValue}>{serv.frguServName}</div>
                      </div>
                    )}
                  </Fragment>
                ))}
              </>
            )}
          </Fragment>
        ))}
      </>
    )}

    {!!passportData.inspectors?.length && (
      <span className={styles.SectionTitle}>Должностные лица, уполномоченные на проведение проверки</span>
    )}
    {!!passportData.inspectors?.length &&
      passportData.inspectors.map((inspector, inspectorIndex) => (
        <Fragment key={inspectorIndex}>
          <span className={styles.SectionTitle}>
            {`Должностное лицо, уполномоченное на проведение КНМ №${inspectorIndex + 1}`}
          </span>
          <div className={styles.Row}>
            <div className={styles.ColText}>ФИО должностного лица, уполномоченного на проведение КНМ</div>
            <div className={styles.ColValue}>{inspector.fullName}</div>
          </div>
          <div className={styles.Row}>
            <div className={styles.ColText}>Должность должностного лица, уполномоченного на проведение КНМ</div>
            <div className={styles.ColValue}>{inspector.position}</div>
          </div>
          <div className={styles.Row}>
            <div className={styles.ColText}>Тип должностного лица, уполномоченного на проведение КНМ</div>
            <div className={styles.ColValue}>{inspector.typeName}</div>
          </div>
        </Fragment>
      ))}
  </div>
));
